export class Notification {
	notify(): void {
		throw new Error("You have to implement the method notify.");
	}
}
